import React, { ReactNode, ReactElement, memo } from 'react'
import {
  FullLogo,
  NavMenu,
  styled,
  Rows,
  Columns,
  LinkInternal,
  Flex,
  LinkExternal,
} from '../../design-system'
import { Section } from '../atoms'
import { ScrollLink } from './scroll-link'

const Header = styled(Section)`
  top: 0px;
`

interface PageHeader2019Props {
  children?: ReactNode
  headerBg?: ReactElement
}

export const PageHeader2019 = memo(
  ({ children, headerBg }: PageHeader2019Props) => (
    <Header
      wide
      bgGraphic={headerBg}
      height={children ? '100vh' : undefined}
      overflow="hidden"
      padding={0}
    >
      <Rows height="100%" minHeight="100%">
        <Columns
          z={2}
          alignItems="flex-start"
          padding={{ mobile: 2, desktop: 3 }}
          paddingVertical={2}
        >
          <LinkInternal to="/">
            <FullLogo fill="contentAlt" scale={{ mobile: 0.55, tablet: 0.8 }} />
          </LinkInternal>
          <Flex />
          <NavMenu>
            <ScrollLink path="/" id="about">
              About
            </ScrollLink>
            <LinkInternal to="/festival/2019/programme">Programme</LinkInternal>
            <LinkExternal href="https://www.tickettailor.com/events/theworldtransformed">
              Tickets
            </LinkExternal>
            <ScrollLink path="/" id="get-involved">
              Get Involved
            </ScrollLink>
            <ScrollLink path="/" id="faqs">
              FAQs
            </ScrollLink>
            <LinkExternal href="https://donorbox.org/the-world-transformed">
              Donate
            </LinkExternal>
          </NavMenu>
        </Columns>
        {children}
      </Rows>
    </Header>
  ),
)
